'use strict';

import googleMapDirective from './google-map';

const MODULE_NAME = 'daupler.maps';

const app = angular.module(MODULE_NAME, []);
app.directive('dauplerGoogleMap', googleMapDirective);

export default MODULE_NAME;
